<template>
  <div class="select-identity comp-container">
    <div v-if="!isElectron" class="close-btn" @click="handleClose">
      <img src="../../../assets/images/login/close.png" alt="" />
    </div>

    <div class="title">选择你的身份</div>
    <div class="desc">以帮助我们更精准的为你推荐内容</div>
    <div class="identity-list">
      <div
        class="item"
        :class="{ selected: selectedIdentity === identity.id }"
        v-for="identity in identities"
        :key="identity.id"
        @click="handleSelectIdentity(identity.id)"
      >
        <div class="img-box">
          <img :src="identity.image" alt="" />
        </div>
        <div class="item-description">{{ identity.name }}</div>
      </div>
    </div>
    <div class="btn-box">
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </div>
</template>

<script>
import { selectIdentity } from "@saas/server-api/src/user-info/auth";
import Login from "@saas/components/src/mixins/login.js";
import { uploadLiveLog, forceFlushLogs } from "@saas/components/src/utils/log";
export default {
  mixins: [Login],
  data() {
    return {
      identities: [
        {
          id: 1,
          name: "学员",
          image: require("../../../assets/images/login/student-id.png"),
        },
        {
          id: 2,
          name: "机构",
          image: require("../../../assets/images/login/org-id.png"),
        },
      ],
      selectedIdentity: 1,
      isElectron: window.isElectron,
    };
  },
  mounted() {
    // 上传日志：选择身份页加载
    uploadLiveLog({
      message: "选择身份页加载",
      module: "login",
      level: "info",
      tag: "pageLoad",
      extra: {
        component: "SelectIdentity",
      },
    });
  },
  beforeDestroy() {
    // 页面销毁前上传所有日志
    forceFlushLogs().catch((err) => {
      console.error("页面销毁前上传日志失败:", err);
    });
  },
  methods: {
    handleSelectIdentity(id) {
      // 上传日志：选择身份
      uploadLiveLog(
        {
          message: "选择身份",
          module: "login",
          level: "info",
          tag: "userAction",
          extra: {
            component: "SelectIdentity",
            identityId: id,
          },
        },
        true
      );
      this.selectedIdentity = id;
    },
    handleConfirm() {
      // 上传日志：确认选择身份
      uploadLiveLog(
        {
          message: "确认选择身份",
          module: "login",
          level: "info",
          tag: "userAction",
          extra: {
            component: "SelectIdentity",
            identityId: this.selectedIdentity,
          },
        },
        true
      );

      selectIdentity({ user_identity: this.selectedIdentity })
        .then((res) => {
          if (res.code === 1) {
            // 上传日志：选择身份成功
            uploadLiveLog(
              {
                message: "选择身份成功",
                module: "login",
                level: "info",
                tag: "userAction",
                extra: {
                  component: "SelectIdentity",
                  identityId: this.selectedIdentity,
                },
              },
              true
            );
            this.$message.success("选择身份成功");
            this.loginSuccess();
          } else {
            // 上传日志：选择身份失败
            uploadLiveLog(
              {
                message: "选择身份失败",
                module: "login",
                level: "error",
                tag: "userAction",
                extra: {
                  component: "SelectIdentity",
                  identityId: this.selectedIdentity,
                  errorCode: res.code,
                  errorMessage: res.message,
                },
              },
              true
            );
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          // 上传日志：选择身份异常
          uploadLiveLog(
            {
              message: "选择身份异常",
              module: "login",
              level: "error",
              tag: "userAction",
              extra: {
                component: "SelectIdentity",
                identityId: this.selectedIdentity,
                error: error?.message || String(error),
              },
            },
            true
          );
        });
    },
    handleClose() {
      // 上传日志：关闭选择身份页
      uploadLiveLog(
        {
          message: "关闭选择身份页",
          module: "login",
          level: "info",
          tag: "userAction",
          extra: {
            component: "SelectIdentity",
          },
        },
        true
      );
      this.loginSuccess();
    },
  },
};
</script>

<style lang="scss" scoped>
.select-identity {
  width: 480px;
  height: 550px;
  overflow: hidden;
  box-shadow: 0px 2px 10px 0px rgba(156, 175, 154, 0.17);
  border-radius: 24px;
  .close-btn {
    position: absolute;
    top: 30px;
    right: 28px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    height: 34px;
    font-weight: 600;
    font-size: 24px;
    background: linear-gradient(
      39.95978872880086deg,
      rgba(59, 255, 61, 0.5) 0%,
      rgba(0, 0, 0, 1) 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    text-align: center;
    margin-top: 80px;
  }
  .desc {
    height: 22px;

    font-weight: 400;
    font-size: 16px;
    color: #515350;
    text-align: center;
    margin-top: 11px;
  }
  .identity-list {
    display: flex;
    margin-top: 60px;
    justify-content: center;
    gap: 60px;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .img-box {
        width: 118px;
        height: 118px;
        background: #f2f3f5;
        border-radius: 0px 0px 0px 0px;
        border: 3px solid #f2f3f5;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        // &:hover {
        //   border: 3px solid #00eb81;
        //   background: #e0fff8;
        // }
        img {
          width: 80px;
          height: 80px;
        }
      }
      .item-description {
        height: 20px;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        margin-top: 12px;
      }
    }
    .selected {
      .img-box {
        border: 3px solid #00eb81;
        background: #e0fff8;
      }
    }
  }
  .btn-box {
    padding: 0 48px;
    margin-top: 78px;
    .el-button {
      width: 100%;
      height: 50px;
      border-radius: 16px !important;
      border: none;
      color: #fff !important;
      font-size: 16px;
      font-weight: 600;
      background: linear-gradient(
        132deg,
        rgba(0, 235, 129, 1) 0%,
        rgba(0, 200, 157, 1) 100%
      );
      &:hover {
        color: #fff !important;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1) 0%,
          rgba(0, 200, 157, 1) 100%
        ) !important;
      }
      &:focus {
        color: #fff !important;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1) 0%,
          rgba(0, 200, 157, 1) 100%
        ) !important;
      }
      &.is-disabled {
        color: #fff !important;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 0.5) 0%,
          rgba(0, 200, 157, 0.5) 100%
        );
        &:hover {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 0.5) 0%,
            rgba(0, 200, 157, 0.5) 100%
          ) !important;
        }
        &:focus {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 0.5) 0%,
            rgba(0, 200, 157, 0.5) 100%
          ) !important;
        }
      }
    }
  }
}
</style>
